import React from 'react';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import Modal from 'components/Modal';
import { i18n } from 'utils/i18n';
import PrerateAdditionalInfoModalContent from 'components/PrerateAdditionalInfoModalContent';

const PrerateAdditionalInfoModal = () => (
  <Modal
    modalKey={MODAL.PRE_RATE_ADDITIONAL_INFO_MODAL}
    header={i18n('prerate_add_additional_info_main_title')}
    theme={MODAL_THEMES.WHITE}
  >
    {() => <PrerateAdditionalInfoModalContent describedByID={`${MODAL.PRE_RATE_ADDITIONAL_INFO_MODAL}_desc`} />}
  </Modal>
);

export default PrerateAdditionalInfoModal;
